import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { usePubSubRetrier } from 'conversations-internal-pub-sub/redux/hooks/usePubSubRetrier';
import { startPubSub } from '../actions/startPubSub';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PubSubErrorAlertText = ({
  isNetworkConnected = true
}) => {
  const {
    isRetrying,
    retry
  } = usePubSubRetrier(startPubSub);
  const message = !isNetworkConnected ? /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "conversations-inbox-ui.banners.pubSubFailure.networkError"
  }) : /*#__PURE__*/_jsx(FormattedHTMLMessage, {
    message: "conversations-inbox-ui.banners.pubSubFailure.message"
  });
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [message, ' ', isRetrying ? /*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.banners.pubSubFailure.reconnecting"
    }) : /*#__PURE__*/_jsx(Link, {
      onClick: retry,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.banners.pubSubFailure.reconnect"
      })
    })]
  });
};
PubSubErrorAlertText.displayName = 'PubSubErrorAlertText';
export default PubSubErrorAlertText;